import React, { FC } from "react";
import { FcGoogle } from "react-icons/fc";

import firebase from "helpers/firebase";
import { SignInButton } from "./SignInButton";
import { logEvent } from "../../../../../helpers/analytics";

export interface GoogleSignInProps {
  isRegistration?: boolean;
}

export const GoogleSignIn: FC<GoogleSignInProps> = ({ isRegistration }) => {
  const handleGoogleSignIn = () => {
    isRegistration
      ? logEvent("sign_up_with_google_btn_clicked")
      : logEvent("sign_in_with_google_btn_clicked");
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithRedirect(provider);
  };

  return (
    <SignInButton onClick={handleGoogleSignIn}>
      <FcGoogle />
      <p>Sign {isRegistration ? "up" : "in"} with Google</p>
    </SignInButton>
  );
};
